/* AV: reconcile Zoorix's initial selection with Dawn's validated variant deep link.
 * Zoorix already handles later changes through its locationchange listener.
 * Keep all price, option, cart and analytics behaviour in the existing components.
 */
(() => {
  function syncInitialVariant() {
    const product = document.querySelector('main product-info[data-update-url="true"]');
    const nativeId = product?.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value;
    const linkedId = new URL(window.location.href).searchParams.get('variant');
    const stickyProduct = window.zoorix_sticky_atc_product;
    const store = window.ZoorixStickyAtc?.store;

    // Ignore other templates, invalid links and products not handled by this bar.
    if (!nativeId || nativeId !== linkedId || !store ||
        String(stickyProduct?.id) !== product.dataset.productId ||
        !stickyProduct.variants?.some(variant => String(variant.id) === nativeId) ||
        String(store.getters.selectedVariant?.id) === nativeId) return;

    // The app installs this listener before announcing zrx-satc-loaded.
    // No URL rewrite, extra add-to-cart request or synthetic commerce event.
    window.dispatchEvent(new Event('locationchange'));
  }

  document.addEventListener('zrx-satc-loaded', syncInitialVariant);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncInitialVariant, { once: true });
  } else {
    syncInitialVariant();
  }
})();
